import { render, staticRenderFns } from "./PlayArea.vue?vue&type=template&id=529a3a6c"
import script from "./PlayArea.vue?vue&type=script&lang=js"
export * from "./PlayArea.vue?vue&type=script&lang=js"
import style0 from "./PlayArea.vue?vue&type=style&index=0&id=529a3a6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports